import { InterestArea, ParticipationMethod } from './types';
import { t } from '../../../../shared/components/l10n/l10n';

const participationKeyMap = {
    [ParticipationMethod.Surveys]: 'surveys',
    [ParticipationMethod.Tests]: 'tests',
    [ParticipationMethod.OnsiteAtCustomer]: 'customer',
    [ParticipationMethod.OnsiteAtEconomic]: 'economic',
};

export const participationMethods = {
    [participationKeyMap[ParticipationMethod.Surveys]]: t`USER_PANEL_STEP_PARTICIPATION_METHOD_SURVEYS`,
    [participationKeyMap[ParticipationMethod.Tests]]: t`USER_PANEL_STEP_PARTICIPATION_METHOD_TESTS`,
    [participationKeyMap[ParticipationMethod.OnsiteAtCustomer]]: t`USER_PANEL_STEP_PARTICIPATION_METHOD_ONSITE_AT_CUSTOMER`,
    [participationKeyMap[ParticipationMethod.OnsiteAtEconomic]]: t`USER_PANEL_STEP_PARTICIPATION_METHOD_ONSITE_AT_ECONOMIC`,
};

const InterestAreaKeyMap = {
    [InterestArea.InventoryFeedbackGroup]: 'inventoryFeedbackGroup',
};

export const InterestAreas = {
    [InterestAreaKeyMap[InterestArea.InventoryFeedbackGroup]]: t`USER_PANEL_AREASOFINTEREST_INVENTORY_FEEDBACK_GROUP`,
};

export const languages = {
    da: `LABEL_LANGUAGE_DANISH`,
    en: `LABEL_LANGUAGE_ENGLISH`,
};

export const parseRegistration = (data: any) => {
    const values = {
        ...data,
        languages: {
            da: false,
            en: false,
        },
        participation: {
            [participationKeyMap[ParticipationMethod.Surveys]]: false,
            [participationKeyMap[ParticipationMethod.Tests]]: false,
            [participationKeyMap[ParticipationMethod.OnsiteAtCustomer]]: false,
            [participationKeyMap[ParticipationMethod.OnsiteAtEconomic]]: false,
        },
        interestAreas: {
            [InterestAreaKeyMap[InterestArea.InventoryFeedbackGroup]]: false,
        },
    };

    data.languages.forEach(language => {
        values.languages[language] = true;
    });
    data.participation.forEach(method => {
        values.participation[participationKeyMap[method]] = true;
    });
    data.interestAreas?.forEach(area => {
        values.interestAreas[InterestAreaKeyMap[area]] = true;
    });

    return values;
};

export const formatRegistration = (values: any) => {
    const data = { ...values };

    data.languages = Object.keys(values.languages).filter(key => !!values.languages[key]);
    data.participation = Object.keys(values.participation)
        .filter(method => !!values.participation[method])
        .map(method => Object.keys(participationKeyMap).find(key => participationKeyMap[key] === method));
    data.interestAreas =
        values.interestAreas &&
        Object.keys(values.interestAreas)
            .filter(area => !!values.interestAreas[area])
            .map(area => Object.keys(InterestAreaKeyMap).find(key => InterestAreaKeyMap[key] === area));
    return data;
};

export const hasEnLangCode = (code: string) => {
    return code === 'en-GB' || code === 'en-GL';
};
